import React, { ElementType } from "react";
import { IconButton } from "@mui/material";
import NextLink from "next/link";

export default function SocialIcon({
  link,
  title,
  icon,
}: {
  link: string;
  title: string;
  icon: ElementType;
}) {
  return (
    <IconButton
      component={NextLink}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={title}
      size="small"
      sx={{
        width: "2rem",
        height: "2rem",
        color: "inherit",
        border: "1px solid",
        borderColor: "custom.footerRule",
        borderRadius: 0,
        transition: "background-color .2s ease, border-color .2s ease",
        "& .MuiSvgIcon-root": { fontSize: "1rem" },
        "&:hover": {
          backgroundColor: "custom.footerText",
          borderColor: "custom.footerText",
          color: "custom.footerBand",
        },
      }}
    >
      {React.createElement(icon, { fontSize: "inherit" })}
    </IconButton>
  );
}
